import React, { useState, useEffect, useCallback } from "react";
import {
  Page,
  Layout,
  Card,
  DataTable,
  Badge,
  Spinner,
  Banner,
  EmptyState,
  Text,
  Link,
  Box,
} from "@shopify/polaris";
import { useShop } from "../context/ShopContext.jsx";
import { useI18n } from "../context/I18nContext.jsx";

const HOST = window.location.origin;

export default function SessionsPage() {
  const { apiFetch, shopDomain } = useShop();
  const { t } = useI18n();
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadSessions = useCallback(async () => {
    setLoading(true);
    try {
      const data = await apiFetch("/fitting-session");
      setSessions(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [apiFetch]);

  useEffect(() => {
    loadSessions();
  }, [loadSessions, shopDomain]);

  const rows = sessions.map((s) => [
    s.customerEmail,
    s.productId,
    new Date(s.createdAt).toLocaleString("nl-NL"),
    <Badge tone={s.emailSent ? "success" : "warning"}>
      {s.emailSent ? t("sessions.sent") : t("sessions.notSent")}
    </Badge>,
    <Link url={`${HOST}/landing/${s.landingPageToken}`} external>
      {t("common.edit")}
    </Link>,
  ]);

  return (
    <Page title={t("sessions.title")}>
      <Layout>
        {error && (
          <Layout.Section>
            <Banner tone="critical" onDismiss={() => setError(null)}>
              {error}
            </Banner>
          </Layout.Section>
        )}
        <Layout.Section>
          <Card>
            <Box padding="400">
              <Text variant="bodyMd" tone="subdued">
                {t("sessions.description")}
              </Text>
            </Box>
            {loading ? (
              <Box padding="400">
                <Spinner />
              </Box>
            ) : sessions.length === 0 ? (
              <EmptyState
                heading={t("sessions.noSessions")}
                image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
              >
                <p>{t("sessions.noSessionsDesc")}</p>
              </EmptyState>
            ) : (
              <DataTable
                columnContentTypes={["text", "text", "text", "text", "text"]}
                headings={[t("sessions.emailCol"), t("sessions.productIdCol"), t("sessions.dateCol"), t("sessions.emailStatus"), t("sessions.landingPageCol")]}
                rows={rows}
              />
            )}
          </Card>
        </Layout.Section>
      </Layout>
    </Page>
  );
}
